import React from 'react'

import { useTranslation } from 'react-i18next'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

import GenericErrorPage from '@pages/errors/GenericErrorPage'
import DashboardNeedPremium from '@pages/home/dashboard/DashboardNeedPremium'
import { usePageTitle } from '@providers/LayoutProvider'

const DashboardError: React.FC = () => {
  const { t } = useTranslation()
  const error = useRouteError()

  usePageTitle(t('titles.dashboard'))

  if (isRouteErrorResponse(error)) {
    if (error.statusText === 'premium_required') {
      return <DashboardNeedPremium />
    }
  }
  return <GenericErrorPage titleKey="messages.dashboardLoadingFailed" />
}

export default DashboardError
